import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import classNames from "classnames";
export const DROPDOWN_MENU_ITEM_BASE_CLASS_NAME = "group/dropdown-menu-item flex shrink-0 cursor-pointer rounded px-1.5 text-inherit outline-none radix-disabled:cursor-not-allowed radix-disabled:bg-transparent radix-disabled:opacity-50 radix-highlighted:bg-grey-4 hover:bg-grey-4 items-center min-h-[32px]";
export const dropdownMenuItem = tailwindVariants({
    base: DROPDOWN_MENU_ITEM_BASE_CLASS_NAME,
    variants: {
        description: {
            false: "items-center py-0",
            true: "items-start py-1.5"
        },
        size: {
            small: "min-h-[32px] text-14",
            large: "min-h-[36px] text-16"
        }
    },
    compoundVariants: [
        {
            description: true,
            size: "small",
            className: "h-auto"
        },
        {
            description: true,
            size: "large",
            className: "h-auto"
        }
    ],
    defaultVariants: {
        description: false,
        size: "small"
    }
});
export const DropdownMenuItem = (param)=>{
    let { children, className, description, label, prefix, shortcut, size = "small", suffix, ...restOfProps } = param;
    const hasDescription = !!description;
    const isSmall = size === "small";
    return /*#__PURE__*/ _jsx(RadixDropdownMenu.Item, {
        className: className || description || size && !isSmall ? dropdownMenuItem({
            className,
            description: !!description,
            size
        }) : DROPDOWN_MENU_ITEM_BASE_CLASS_NAME,
        "data-testid": "DROPDOWN_MENU_ITEM",
        ...restOfProps,
        children: !!children ? children : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !!prefix ? /*#__PURE__*/ _jsx("div", {
                    className: classNames("mr-2 flex shrink-0 items-center", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                    children: prefix
                }) : null,
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex min-w-0 grow flex-col",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: classNames("truncate", isSmall ? "text-14" : "text-16"),
                            children: label
                        }),
                        hasDescription ? /*#__PURE__*/ _jsx("span", {
                            className: classNames("text-grey-10", isSmall ? "text-12" : "text-14"),
                            children: description
                        }) : null
                    ]
                }),
                !!suffix ? /*#__PURE__*/ _jsx("div", {
                    className: classNames("ml-2 flex shrink-0 items-center", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                    children: suffix
                }) : null,
                !!shortcut ? /*#__PURE__*/ _jsx("div", {
                    className: "ml-2 flex shrink-0 items-center",
                    children: shortcut.map((key, index)=>/*#__PURE__*/ _jsx("kbd", {
                            className: "mr-0.5 flex size-4 items-center justify-center rounded bg-grey-3 text-10 uppercase text-grey-8 last:mr-0",
                            children: key
                        }, index))
                }) : null
            ]
        })
    });
};
